import { useInjectReducer } from "utils/@reduxjs/useInjectReducer";
import { leadsOptedInTasSaga } from "./saga";
import { useInjectSaga } from "utils/@reduxjs/useInjectSaga";
import { createSlice } from "@reduxjs/toolkit";
import { useMemo } from "react";

export const initialState = {
  leadsOptedInList: {
    initialLoading: true,
    loading: false,
    error: null,
    records: [],
    pagination: ""
  },
  createLeadsOptedIn: {
    loading: false,
    error: null,
    success: false
  },
  reOptIn: {
    loading: false,
    error: null,
    success: false
  },
  updateLeadsOptedIn: {
    loading: false,
    error: null,
    success: false
  },
  deleteLeadsOptedIn: {
    loading: false,
    error: null,
    success: false
  }
};

export const LeadsOptedInTasSlice = createSlice({
  name: "leadsOptedInTas",
  initialState,
  reducers: {
    // --- Fetch Leads Opted In List ---
    fetchLeadsOptedInList: (state) => {
      state.leadsOptedInList.loading = true;
      if (state.leadsOptedInList.initialLoading) {
        state.leadsOptedInList.initialLoading = true;
      }
      state.leadsOptedInList.error = null;
    },
    fetchLeadsOptedInListSuccess: (state, action) => {
      const { records, pagination } = action.payload;
      state.leadsOptedInList.loading = false;
      state.leadsOptedInList.initialLoading = false;
      state.leadsOptedInList.error = null;
      state.leadsOptedInList.records = records || [];
      state.leadsOptedInList.pagination = pagination || {};
    },
    fetchLeadsOptedInListError: (state, action) => {
      state.leadsOptedInList.loading = false;
      state.leadsOptedInList.initialLoading = false;
      state.leadsOptedInList.error = action.payload;
    },

    // --- Create Leads Opted In ---
    createLeadsOptedIn: (state) => {
      state.createLeadsOptedIn.loading = true;
      state.createLeadsOptedIn.error = null;
      state.createLeadsOptedIn.success = false;
    },
    createLeadsOptedInSuccess: (state) => {
      state.createLeadsOptedIn.loading = false;
      state.createLeadsOptedIn.error = null;
      state.createLeadsOptedIn.success = true;
    },
    createLeadsOptedInError: (state, action) => {
      state.createLeadsOptedIn.loading = false;
      state.createLeadsOptedIn.error = action.payload;
      state.createLeadsOptedIn.success = false;
    },
    resetCreateLeadsOptedIn: (state) => {
      state.createLeadsOptedIn = initialState.createLeadsOptedIn;
    },

    reOptIn: (state) => {
      state.reOptIn.loading = true;
      state.reOptIn.error = null;
      state.reOptIn.success = false;
    },
    reOptInSuccess: (state) => {
      state.reOptIn.loading = false;
      state.reOptIn.success = true;
    },
    reOptInError: (state, action) => {
      state.reOptIn.loading = false;
      state.reOptIn.error = action.payload;
    },
    resetReOptIn: (state) => {
      state.reOptIn = initialState.reOptIn;
    },

    updateLeadsOptedIn: (state) => {
      state.updateLeadsOptedIn.loading = true;
      state.updateLeadsOptedIn.error = null;
      state.updateLeadsOptedIn.success = false;
    },
    updateLeadsOptedInSuccess: (state) => {
      state.updateLeadsOptedIn.loading = false;
      state.updateLeadsOptedIn.success = true;
    },
    updateLeadsOptedInError: (state, action) => {
      state.updateLeadsOptedIn.loading = false;
      state.updateLeadsOptedIn.error = action.payload;
    },
    resetUpdateLeadsOptedIn: (state) => {
      state.updateLeadsOptedIn = initialState.updateLeadsOptedIn;
    },

    deleteLeadsOptedIn: (state) => {
      state.deleteLeadsOptedIn.loading = true;
      state.deleteLeadsOptedIn.error = null;
      state.deleteLeadsOptedIn.success = false;
    },
    deleteLeadsOptedInSuccess: (state) => {
      state.deleteLeadsOptedIn.loading = false;
      state.deleteLeadsOptedIn.success = true;
    },
    deleteLeadsOptedInError: (state, action) => {
      state.deleteLeadsOptedIn.loading = false;
      state.deleteLeadsOptedIn.error = action.payload;
    },
    resetDeleteLeadsOptedIn: (state) => {
      state.deleteLeadsOptedIn = initialState.deleteLeadsOptedIn;
    }
  }
});

export const useLeadsOptedInTasSlice = () => {
  useInjectReducer(LeadsOptedInTasSlice.name, LeadsOptedInTasSlice.reducer);
  useInjectSaga(LeadsOptedInTasSlice.name, leadsOptedInTasSaga);
  const actions = useMemo(() => LeadsOptedInTasSlice.actions, []);
  return { actions };
};

export const { actions: LeadsOptedInTasActions } = LeadsOptedInTasSlice;
export default LeadsOptedInTasSlice.reducer;
